module.exports = __webpack_public_path__ + "static/media/Randy Glick Headshot.690aae8f.jpeg";